export const interviewSummary = [
  { title: "Active Jobs", value: 20, color: "bg-green-100", icon: "FileOutlined" },
  { title: "In Pipeline", value: 20, color: "bg-orange-100", icon: "BranchesOutlined" },
  { title: "Pre-Onboarding", value: 20, color: "bg-teal-100", icon: "UserOutlined" },
  { title: "Offers Sent", value: 20, color: "bg-purple-100", icon: "MailOutlined" },
  { title: "Offers Accepted", value: 20, color: "bg-cyan-100", icon: "CheckCircleOutlined" },
  { title: "Upcoming Interviews", value: 20, color: "bg-red-100", icon: "CalendarOutlined" },
];

export const hiringTrendsData = [
  { month: "Jan", value: 10 },
  { month: "Feb", value: 15 },
  { month: "Mar", value: 7 },
  { month: "Apr", value: 5 },
  { month: "May", value: 11 },
  { month: "Jun", value: 15 },
  { month: "Jul", value: 7 },
  { month: "Aug", value: 16 },
  { month: "Sep", value: 13 },
  { month: "Oct", value: 3 },
  { month: "Nov", value: 10 },
  { month: "Dec", value: 12 },
];
export const todayInterviews = [
  { time: "10:30 AM", title: "L1 Round : Mike Wood", interviewer: "Jack King", color: "border-purple-500", bg: "bg-purple-100" },
  { time: "11:00 AM", title: "L2 Round : John V.C", interviewer: "Jack King", color: "border-red-400", bg: "bg-red-100" },
  { time: "11:30 AM", title: "Salary Discussion : Jack", interviewer: "Jack King", color: "border-green-400", bg: "bg-green-100" },
  { time: "12:00 PM", title: "L1 Round : Mike Wood", interviewer: "Jack King", color: "border-purple-400", bg: "bg-purple-50" },
  { time: "12:30 PM", title: "L1 Round : Mike Wood", interviewer: "Jack King", color: "border-orange-400", bg: "bg-orange-100" },
];
